import type { AudiencePlatformItem, CountryItem } from '@digiseg-labs/api-client';

const STORAGE_KEYS = {
  country: 'audience:selectedCountry',
  platform: 'audience:selectedPlatform',
  welcomeDismissed: 'audience:welcomeDismissed',
} as const;

const isBrowser = typeof window !== 'undefined';

export const getStoredCountryCode = () =>
  (isBrowser ? window.localStorage.getItem(STORAGE_KEYS.country) : null);

export const setStoredCountryCode = (code?: string | null) => {
  if (!isBrowser) return;
  if (code) {
    window.localStorage.setItem(STORAGE_KEYS.country, code);
  } else {
    window.localStorage.removeItem(STORAGE_KEYS.country);
  }
};

export const getStoredPlatformCode = () =>
  (isBrowser ? window.localStorage.getItem(STORAGE_KEYS.platform) : null);

export const setStoredPlatformCode = (code?: string | null) => {
  if (!isBrowser) return;
  if (code) {
    window.localStorage.setItem(STORAGE_KEYS.platform, code);
  } else {
    window.localStorage.removeItem(STORAGE_KEYS.platform);
  }
};

export const getWelcomeDismissed = () =>
  (isBrowser ? window.localStorage.getItem(STORAGE_KEYS.welcomeDismissed) === 'true' : false);

export const setWelcomeDismissed = (value: boolean) => {
  if (!isBrowser) return;
  if (value) {
    window.localStorage.setItem(STORAGE_KEYS.welcomeDismissed, 'true');
  } else {
    window.localStorage.removeItem(STORAGE_KEYS.welcomeDismissed);
  }
};

export const clearInvalidStoredSelections = (
  countries: CountryItem[] = [],
  platforms: AudiencePlatformItem[] = [],
) => {
  if (!isBrowser) return;

  const storedCountry = getStoredCountryCode();
  if (storedCountry && !countries.some((c) => c.code === storedCountry)) {
    setStoredCountryCode(null);
  }

  const storedPlatform = getStoredPlatformCode();
  if (storedPlatform && !platforms.some((p) => p.code === storedPlatform)) {
    setStoredPlatformCode(null);
  }
};
